import { z } from 'zod';
import { userSummarySchema } from './users.js';
/**
 * GET /api/units/roster — every soldier in the caller's roster reach, with
 * the unit names and the per-soldier counts the org page's grid shows
 * (owner, 2026-09-13: "see all the soldiers in one place by platoons and
 * teams"). One read for the whole page; the grid sorts and filters
 * client-side.
 */
export const orgRosterRowSchema = userSummarySchema.extend({
    platoonName: z.string().nullable(),
    teamName: z.string().nullable(),
    /** Open assignments (issued and not yet closed), unsigned forms, overdue mission items. */
    openGear: z.number().int().min(0),
    unsignedForms: z.number().int().min(0),
    overdue: z.number().int().min(0),
});
export const orgRosterResponseSchema = z.object({
    rows: z.array(orgRosterRowSchema),
    /** Ids of the units the caller may open — the panel greys out the rest. */
    viewableUnitIds: z.array(z.string()),
    generatedAt: z.string(),
});
//# sourceMappingURL=orgRoster.js.map